import { useTranslation } from 'react-i18next';
import type { StylesConfig } from 'react-select';

export type Option<V> = {
	value: V;
	label: string;
	subtitle?: string;
	highlight?: boolean;
};

// menu portato su body: tabella e card lo taglierebbero
export const portalStyles: StylesConfig<any, boolean> = {
	menuPortal: (base) => ({ ...base, zIndex: 1090 }),
};

export const portalProps = {
	menuPortalTarget: document.body,
	styles: portalStyles,
};

export const useSelectLabels = () => {
	const { t } = useTranslation();
	return {
		noOptions: () => t('no_options', { defaultValue: 'Nessuna opzione' }),
		makeLabel: t('vehicle_association_select_make', {
			defaultValue: 'Seleziona marca',
		}),
		modelLabel: t('vehicle_association_select_model', {
			defaultValue: 'Seleziona modello',
		}),
		versionLabel: t('vehicle_association_select_version', {
			defaultValue: 'Seleziona versione',
		}),
	};
};

export const formatWithSubtitle = (
	option: Option<string>,
	{ context }: { context: 'menu' | 'value' }
) =>
	context === 'menu' && option.subtitle ? (
		<div>
			<div>{option.label}</div>
			<small
				className={option.highlight ? 'text-success fw-semibold' : 'opacity-75'}
			>
				{option.subtitle}
			</small>
		</div>
	) : (
		option.label
	);
